import { useEffect } from "react";
//context
import { useGlobalContext } from "../contexts";
//apollo
import client from "../src/utils/apollo/client"
//queries
import { GET_HOMEPAGE } from "../src/queries/pages/get-homepage";
// Components
import Layout from "../src/components/layout"

export default function Home( {data} ) {
  const { context, setContext } = useGlobalContext();

  useEffect(() => {
    if (!context.isSet) {
      data.context.options.isSet = true;
      setContext(data.context.options);
    }
  }, []);

  return (
    <Layout
      logos={data?.logos?.options?.logos}
      mainMenu={data?.mainMenu?.edges}
      menuFooter={data?.menuFooter?.edges}
      seo={data?.content?.seo}
      breadcrumbs={data?.content?.seo?.breadcrumbs}
      content={data?.content}
      pt_key={process.env.HP_PT_KEY}
      templateWhite={data?.content?.acfSidebar?.bgWhite}
      optionsFooter={data?.content?.acfSidebar?.optionsFooter}
      testimonies={data?.testimonies?.nodes}
      programms={data?.programms}
      partners={data?.partners?.options?.partners}
      lastnews={data?.lastnews?.nodes}
      isHome={true}
    ></Layout>
  )
}

export async function getStaticProps() {
  try {
    const { data, errors } = await client.query({
      query: GET_HOMEPAGE(process.env.HP_PT_KEY),
      variables: {
        programmsCategoryId: parseInt(process.env.PRODUCT_PROGRAMM_CATEGORY_ID),
      },
      fetchPolicy: "no-cache",
    });

    if (errors?.length) {
      console.error("[ISR][HOME] GraphQL errors:", errors);
      throw new Error("GraphQL errors while fetching homepage");
    }

    if (!data || typeof data.content === "undefined" || data.content === null) {
      console.error("[ISR][HOME] Invalid homepage data:", {
        hasData: !!data,
        content: data?.content,
      });

      throw new Error("Invalid homepage data");
    }

    return {
      props: {
        data,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("[ISR][HOME] Failed to regenerate:", error);
    throw error;
  }
}